import { Injectable } from '@angular/core';
import { NgxMatNativeDateAdapter } from '../../standalone-packages/angular-material-components-master/projects/datetime-picker/src/lib/core/native-date-adapter';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

@Injectable()
export class CustomDateAdapter extends NgxMatNativeDateAdapter {
    override getFirstDayOfWeek(): number {
        return 1;
    }
}

export class MomentCustomDateAdapter extends MomentDateAdapter {
    override getFirstDayOfWeek(): number {
        return 1;
    }
}
